import LocalizedStrings from "react-localization";

export const strings = new LocalizedStrings({
  en: {
    notification_text: "weUseCookie",
    cookie_policy: "Cookie Policy",
    continue_btn: "Continue",
    cookies_link: "Cookies",
    imprint_link: "Imprint",
    privacy_link: "Privacy",
    terms_link: "Terms",
  },
  ko: {
    notification_text:
      "We use cookies on the Talaera site to provide the best experience. " +
      "If you continue without changing your settings, you will receive cookies. You can " +
      "change your cookie settings at any time. Read more about our ",
    cookie_policy: "Cookie Policy",
    continue_btn: "Continue",
    cookies_link: "Cookies",
    imprint_link: "Imprint",
    privacy_link: "개인정보 보호정책",
    terms_link: "이용약관",
  },
  de: {
    notification_text:
      "We use cookies on the Talaera site to provide the best experience. " +
      "If you continue without changing your settings, you will receive cookies. You can " +
      "change your cookie settings at any time. Read more about our ",
    cookie_policy: "Cookie Policy",
    continue_btn: "Continue",
    cookies_link: "Cookies",
    imprint_link: "Impressum",
    privacy_link: "Datenschutz",
    terms_link: "AGB",
  },
  es: {
    notification_text:
      "We use cookies on the Talaera site to provide the best experience. " +
      "If you continue without changing your settings, you will receive cookies. You can " +
      "change your cookie settings at any time. Read more about our ",
    cookie_policy: "Cookie Policy",
    continue_btn: "Continue",
    cookies_link: "Cookies",
    imprint_link: "Imprint",
    privacy_link: "Privacidad",
    terms_link: "Términos",
  },
});
